module.exports = __webpack_public_path__ + "1b519b1d2b24460978ef852384cffdf6.png";